<template>
    <transition name="fade" appear>
        <div
            class="cruise-stappen whitebg border2 stap1 width100 marginbottom15"
        >
            <div class="stap-header lichtblauwbg width100">
                <div
                    class="stap-header width60 floatleft fontsize14 bold midblauw padding10 uppercase"
                >
                    Stap {{ this.currentStep }}: Kies een Hut
                </div>
            </div>
            <div class="clear"></div>

            <div class="stap-content width100 overflowhidden " id="stap-hut">
                <Cabin
                    v-for="cabinIndex in cabinCount"
                    :key="'cabin' + cabinIndex"
                    :index="cabinIndex"
                    class="item"
                />
            </div>
        </div>
    </transition>
</template>

<script>
import Cabin from './Cabin.vue'

export default {
    name: 'Cabins',
    components: {
        Cabin,
    },
    props: {
        currentStep: Number,
    },
    data: function() {
        return {
            floorPlanVisible: false,
            highlightDekNumber: null,
        }
    },
    computed: {
        cabinSetup: function() {
            return this.$store.state.cabinSetup
        },
        cabinCount: function() {
            return this.$store.state.cabinCount
        },
        departures: function() {
            return this.$store.state.departures
        },
    },
}
</script>

<style lang="scss" scoped>
.stap-content {
    width: calc(100% - 30px);
    padding-left: 15px;
    padding-right: 15px;
}
</style>
